export default __webpack_public_path__ + "static/media/logo.dfe624cb.png";